const pageNameKey = "replaceBlueprintGradientBoxDescriptionContainer";

export const replaceBlueprintGradientBoxDescriptionContainerEn = {
  [pageNameKey]: {
    descriptionTitle: "Description",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerPtBr = {
  [pageNameKey]: {
    descriptionTitle: "Descrição",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerDe = {
  [pageNameKey]: {
    descriptionTitle: "Beschreibung",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerZhHans = {
  [pageNameKey]: {
    descriptionTitle: "描述",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerIt = {
  [pageNameKey]: {
    descriptionTitle: "Descrizione",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerEs = {
  [pageNameKey]: {
    descriptionTitle: "Descripción",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerNl = {
  [pageNameKey]: {
    descriptionTitle: "Beschrijving",
  },
};

export const replaceBlueprintGradientBoxDescriptionContainerTr = {
  [pageNameKey]: {
    descriptionTitle: "Tanım",
  },
};
